export const BaseURL = "https://api.consoltoeg.com/api";
